//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

/**
 * Clamps the given value to the given range, inclusive.
 *
 * @param val The desired number to clamp.
 * @param min The lower bound of the desired range, inclusive.
 * @param max The upper bound of the desired range, inclusive.
 *
 * @examples
 * clamp(-2, 0, 10) --> 0
 * clamp(3, 0, 10) --> 3
 * clamp(12, 0, 10) --> 10
 */
export function clamp(val: number, min: number, max: number) {
  return Math.min(Math.max(val, min), max);
}
